import { RECIPES, recipeAccepts } from '../content/recipes';
import type { SimEvent } from '../core/events';
import {
  peekPort,
  portHasRoom,
  singleInput,
  singleOutput,
  tryPushToPort,
  tryTakeFromPort,
} from '../core/port';
import { drainOutput } from './shared';
import type { MachineHandler } from './registry';

/**
 * The only operator that transforms anything. A recipe takes either a lone packet or the tuple a
 * join packed, so this is where a tuple stops being a pair of materials and becomes a product —
 * `zip` upstream only packs. A packet the recipe cannot consume is held at the input rather than
 * dropped or errored, whatever its shape: the line backs up visibly instead of losing anything.
 */
export const mapHandler: MachineHandler = {
  kind: 'map',
  step({ state, machine }) {
    if (machine.kind !== 'map') return [];
    const events: SimEvent[] = [];
    const inputPort = singleInput(machine.inputs);
    const outputPort = singleOutput(machine.outputs);

    drainOutput(state, machine, events);

    const waitingId = peekPort(inputPort);
    if (waitingId !== undefined) {
      const packet = state.packets[waitingId];
      if (!packet) {
        tryTakeFromPort(inputPort);
        return events;
      }
      if (machine.config) {
        const recipe = RECIPES[machine.config.recipeId];
        if (recipeAccepts(recipe, packet.material) && portHasRoom(outputPort)) {
          tryTakeFromPort(inputPort);
          packet.material = recipe.to;
          events.push({ type: 'packetTransformed', packetId: waitingId, material: recipe.to });
          tryPushToPort(outputPort, waitingId);
        }
      }
    }

    return events;
  },
};
